import React, { useEffect, useState } from 'react';
import CoachError from './CoachComponents/CoachError';
import ViewCoachPickerButton from './CoachComponents/ViewCoachPickerButton';
import CoachAvatar from './CoachComponents/CoachAvatar';
import CoachMessagePopup from './CoachComponents/CoachMessagePopup';
import { CoachElement } from '@app/common';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../../store/hooks';
import { CoachDataDB, CoachMessageDB } from 'src/data/datatypes';
import { getCoach, getCoachMessage } from 'src/services/DBService/DbService';

type Properties = {
    data: CoachElement
};

const Coach = (props: Properties) => {
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState<boolean>(true);
    const coachId = useAppSelector(state => state.globalState.user?.coachId);
    const [coachData, setCoachData] = useState<CoachDataDB | undefined | null>();
    const [coachMessage, setCoachMessage] = useState<CoachMessageDB | undefined | null>();

    const viewCoachPicker = React.useCallback(() => navigate('/pick-coach'), []);

    useEffect(() => {
        if (coachId !== undefined) {
            const loadData = async () =>  {
                const [data, message] = await Promise.all([
                    getCoach(coachId),
                    getCoachMessage(props.data.messageId)
                ]);
                setCoachData(data);
                setCoachMessage(message);
                setExpanded(true);
            };
            loadData();
        }
    }, [coachId, props.data.messageId]);

    if (coachId === undefined) {
        return (
            <ViewCoachPickerButton
                viewCoachPicker={viewCoachPicker}
                isHidden={false}
            />);
    }

    if (coachData === undefined || coachMessage === undefined) {
        // coach data or message is loading
        return <div>Loading Coach...</div>;
    } else if (coachData === null || coachMessage === null) {
        // coach data or message could not be loaded
        return <CoachError coachId={coachId} messageId={props.data.messageId}/>;
    }

    const toggleExpandCoach = () => {
        setExpanded(!expanded);
    };

    let coachAvatar: JSX.Element;
    coachAvatar = (
        <CoachAvatar
            avatarImagePath={coachData.avatarImagePath}
            toggleExpandCoach={toggleExpandCoach}
        />
    );

    const coachMessagePopup = (
        <CoachMessagePopup
            coachName={coachData.name}
            imagePath={coachData.imagePath || ''}
            message={coachMessage[coachId] || coachMessage.default}
            toggleExpandCoach={toggleExpandCoach}
            isHidden={!expanded}
        />
    );

    return (
    <span data-testid="coach">
        {coachAvatar}
        {coachMessagePopup}
    </span>);
};
export default Coach;